<template>
  <main class="container px-0 px-lg-5">
    <article class="CardConfirmarPedido w-100">
      <div class="">
        <div
          class="my-5 text-black-50 text-center text-uppercase"
          v-if="!objPedido.pedidoDTO"
        >
          <h5>Estamos carregando as informações do seu pedido, aguarde....</h5>
          <div class="spinner-grow" style="width: 3rem; height: 3rem;">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div class="row" v-else>
          <section class="col-12 mt-4 ">
            <strong style="font-size: 1.3em; color: #707070">Carrinho de compras</strong>
            <div class="align-items-end
                 d-flex
                 flex-column
                 justify-content-center
                 text-white">
              <button class="btn btn-sm p-1 " @click="cancelPayment()">
                LIMPAR CARRINHO
              </button>
            </div>
            <hr />
            <ul class="border-bottom pb-3 list-unstyled">
              <li
                v-for="(item, index) of this.objPedido.pedidoDTO.itens"
                :key="index"
                class="d-flex flex-column flex-md-row pb-4"
              >
                <img
                  class="img-thumbnail mr-2 align-self-baseline"
                  v-if="item.produto.imagemList"
                  :src="imagemPrincipal(item.produto.imagemList)"
                  :alt="item.produto.nome"
                  style="max-width: 123px;"
                />
                <div
                  class="d-flex w-100 justify-content-between flex-column flex-md-row"
                >
                  <div class="d-flex flex-column w-100">
                    <strong class="font-size-1-5">
                      {{ item.produto.nome }}
                    </strong>

                    <span>
                      <small style="color: #757575;">
                        Vendido por:
                        <strong>{{ item.produto.redeLoja.nome }}</strong>
                      </small>
                    </span>
                    <small style="color: #757575"> Opções de frete: </small>

                    <ul v-if="item.freteSelecionado &&
                      item.freteSelecionado.tipoCalculoFrete !=
                      'RETIRAR_NA_LOJA'

                      ">
                      <li style="list-style-type: none" v-for="(frete, index) of item.opcoesFrete" :key="index">
                        <small style="color: #757575">
                          <input type="radio" @click="alterarOpcaoFrete(item.id, frete.id)" :name="item.id"
                            :value="frete.id" :checked="frete.id == item.freteSelecionado.id" />
                          <strong v-if="frete.valorTotalFrete > 0">
                            {{ frete.valorTotalFrete | currency }}
                          </strong>
                          <strong v-else> Grátis </strong>
                          entregue por
                          <strong>{{ frete.nomeLogistica }}</strong> em até
                          {{ frete.estimativaEntrega }}.
                        </small>
                      </li>
                    </ul>

                    <span v-if="item.freteSelecionado == null &&
                      objPedido.pedidoDTO != null &&
                      objPedido.pedidoDTO.removerItensSemLogistica
                      " class="text-danger">
                      <ul>
                        <li style="list-style-type: none">
                          <small>
                            Não possuímos logística disponível para realizar a
                            entrega deste produto no CEP informado no momento.
                          </small>
                        </li>
                      </ul>

                      <span
                        v-if="
                          item.freteSelecionado == null &&
                          objPedido.pedidoDTO != null &&
                          objPedido.pedidoDTO.removerItensSemLogistica
                        "
                        class="text-danger"
                      >
                        <ul>
                          <li style="list-style-type: none;">
                            <small>
                              Não possuímos logística disponível para realizar a
                              entrega deste produto no CEP informado no momento.
                            </small>
                          </li>
                        </ul>
                      </span>

                      <span
                        v-if="
                          item.freteSelecionado &&
                          item.freteSelecionado.tipoCalculoFrete ==
                            'RETIRAR_NA_LOJA'
                        "
                      >
                        <small style="color: #757575;">
                          Frete:
                          <strong>
                            {{
                              item.freteSelecionado.valorTotalFrete | currency
                            }}
                          </strong>
                          retirar o produto na loja.
                        </small>
                      </span>
                    </span>
                  </div>
                  <div class="align-items-center d-flex flex-column">
                    <div class="custom-input-number d-flex align-items-center">
                      <button
                        type="button"
                        @click="adicionar(false, item)"
                        :disabled="item.quantidade === 1"
                      >
                        -
                      </button>
                      <span class="px-3">{{ item.quantidade }}</span>
                      <button type="button" @click="adicionar(true, item)">
                        +
                      </button>
                    </div>
                    <small
                      @click="excluirItem(item.id, 0)"
                      class="btn btn-sm p-1"
                    >
                      remover
                    </small>
                  </div>
                  <div class="text-right mt-2 d-flex flex-column">
                    <span
                      class="align-middle ml-4 text-right"
                      style="font-size: 1.3em;"
                    >
                      {{
                        (item.quantidade *
                          (item.produto.valorUnitario +
                            calcAdicional(item.produto)))
                          | currency
                      }}
                    </span>
                  </div>
                </div>
              </li>
            </ul>
            <div class="float-right">
              <div class="d-flex justify-content-between">
                <small class="pr-5">Valor da compra</small>
                <strong>
                  {{ this.$store.state.pedido.valorCompra | currency }}
                </strong>
              </div>
              <div class="d-flex justify-content-between">
                <small class="pr-5">Valor do frete</small>
                <strong>
                  {{
                    !(this.$store.state.pedido.valorFrete > 0)
                      ? '-'
                      : !(this.$store.state.pedido.valorFrete > 0)
                      ? 'Grátis'
                      : this.$store.state.pedido.valorFrete | currency
                  }}
                </strong>
              </div>

              <div class="d-flex justify-content-between">
                <small class="pr-5">Valor do desconto</small>
                <strong>
                  {{
                    !(this.$store.state.pedido.valorDesconto > 0)
                      ? '-'
                      : !(this.$store.state.pedido.valorDesconto > 0)
                      ? 'Grátis'
                      : this.$store.state.pedido.valorDesconto | currency
                  }}
                </strong>
              </div>
              <div class="d-flex justify-content-between font-size-1-5">
                <span class="pr-5">Total</span>
                <strong>
                  {{ this.$store.state.pedido.valorTotal | currency }}
                </strong>
              </div>
            </div>

            <div class="float-right mr-3">

              <!-- <div v-show="!itens.produto.tipo.indexOf('PRODUTO_DIGITAL') >= 0
                    && itens.produto.tipo.indexOf('PRODUTO_FISICO') >= 0" > -->

              <span>CEP de Entrega:</span>
              <form class="input-group" v-on:submit.prevent="calcularFrete">
                <input class="form-control" type="text" v-model="objPedido.pedidoDTO.enderecoEntrega.cep"
                  v-mask="'#####-###'" pattern=".{9}" placeholder="00000-000" style="
                    border-bottom-right-radius: 0;
                    border-top-right-radius: 0;
                    box-shadow: none;
                  " />
                <button class="btn btn-secondary" style="
                    border-bottom-left-radius: 0;
                    border-top-left-radius: 0;
                    box-shadow: none;
                  " :disabled="loadingCalcularFrete" type="submit">
                  <span v-if="!loadingCalcularFrete">Pesquisar</span>
                  <span class="spinner-border" v-else></span>
                </button>
              </form>

                <!-- </div> -->
              <!-- </div> -->

            </div>
            <div>
              <!--v-show="itens.produto.tipo.indexOf('PRODUTO_DIGITAL') >= 0"-->
              <!-- <span v-if="objPedido.pedidoDTO.enderecoEntrega"
                    v-show="!itens.produto.tipo.indexOf('PRODUTO_DIGITAL') >= 0
                    && itens.produto.tipo.indexOf('PRODUTO_FISICO') >= 0"   > -->

              <span>Endereço de entrega</span> <br />
              <small style="color: #757575">
                <strong>CEP:</strong>
                {{ objPedido.pedidoDTO.enderecoEntrega ? objPedido.pedidoDTO.enderecoEntrega.cep : "" }} <br />
                <strong>Endereço: </strong>
                {{ objPedido.pedidoDTO.enderecoEntrega ? objPedido.pedidoDTO.enderecoEntrega.endereco : "" }}<br />
                <strong>Complemento: </strong>
                {{ objPedido.pedidoDTO.enderecoEntrega ? objPedido.pedidoDTO.enderecoEntrega.complemento : "" }} <br />
                <strong>Número: </strong>
                {{ objPedido.pedidoDTO.enderecoEntrega ? objPedido.pedidoDTO.enderecoEntrega.numero : "" }} <br />
                <strong>Bairo: </strong>
                {{ objPedido.pedidoDTO.enderecoEntrega ? objPedido.pedidoDTO.enderecoEntrega.bairro : "" }} <br />
                <strong>Cidade: </strong>{{ objPedido.pedidoDTO.enderecoEntrega ?
                  objPedido.pedidoDTO.enderecoEntrega.cidade : "" }} <br />
                <strong>UF: </strong>{{ objPedido.pedidoDTO.enderecoEntrega ? objPedido.pedidoDTO.enderecoEntrega.estado :
                  "" }}
              </small>
              <!-- </span> -->
            </div>

            <div
              :class="{
                'float-right': objPedido.pedidoDTO.possuiProdutoFisico,
                'float-left': !objPedido.pedidoDTO.possuiProdutoFisico,
              }"
              class="m-2"
            >
              <div v-if="this.objPedido.pedidoDTO.cupom">
                <small>Cupom utilizado</small>
                <span class="text-uppercase small">
                  <b>{{ this.objPedido.pedidoDTO.cupom.codigoCupom }}</b>
                </span>
                <small
                  v-if="
                    this.objPedido.pedidoDTO.cupom.premiacaoTipo ===
                      'PERCENTUAL_DESCONTO' ||
                    this.objPedido.pedidoDTO.cupom.premiacaoTipo ===
                      'CASHBACK_PERCENTUAL'
                  "
                >
                  &nbsp;{{
                    this.objPedido.pedidoDTO.cupom.premiacaoTipo ===
                    'PERCENTUAL_DESCONTO'
                      ? this.objPedido.pedidoDTO.cupom.valorDesconto * 100 +
                        '% de desconto'
                      : ''
                  }}
                </small>
                <small
                  v-if="
                    this.objPedido.pedidoDTO.cupom.premiacaoTipo ===
                      'VALOR_DESCONTO' ||
                    this.objPedido.pedidoDTO.cupom.premiacaoTipo === 'CASHBACK'
                  "
                >
                  &nbsp;{{
                    this.objPedido.pedidoDTO.cupom.valorDesconto | currency
                  }}
                  de desconto
                </small>
              </div>

              <form class="input-group" v-on:submit.prevent="aplicarCupom">
                <input
                  class="form-control"
                  v-model="cupomDesconto"
                  type="text"
                  placeholder="Cupom Desconto"
                  style="
                    border-bottom-right-radius: 0;
                    border-top-right-radius: 0;
                    box-shadow: none;
                  "
                />
                <button
                  class="btn btn_color_system"
                  style="
                    border-bottom-left-radius: 0;
                    border-top-left-radius: 0;
                    box-shadow: none;
                  "
                  :disabled="loadingAplicarCupom"
                  type="submit"
                >
                  <span v-if="!loadingAplicarCupom">Aplicar Cupom</span>
                  <span class="spinner-border" v-else></span>
                </button>
              </form>
              <span
                class="text-danger text-uppercase small"
                v-if="!!cupomError"
              >
                *{{ cupomError }}
              </span>
              <span
                class="text-danger float-right text-uppercase small"
                v-if="this.objPedido.pedidoDTO.cupom"
              >
                <a href="" v-on:click.prevent="removerCupom">Remover cupom</a>
              </span>
            </div>
            <div
              class="float-right mr-3"
              v-if="objPedido.pedidoDTO.possuiProdutoFisico"
            >
              <span
                class="text-danger text-uppercase small"
                v-if="!!freteError"
              >
                *{{ freteError }}
              </span>
            </div>
            <span class="clearfix"></span>
          </section>
          <section v-if="loading" class="loading">
            <div
              class="align-items-center d-flex flex-column h-100 justify-content-center text-white"
            >
              <h4 class="px-4">Processando seu carrinho de compras</h4>
              <div class="spinner-grow" style="width: 3rem; height: 3rem;">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </section>

        </div>
        <div class="
          mt-3
          mb-5
          px-3
          row
          flex-column flex-lg-row
          justify-content-between
        ">
          <button v-if="objPedido.pedidoDTO.possuiProdutoFisico == true" :disabled="objPedido.pedidoDTO != null &&
            objPedido.pedidoDTO.removerItensSemLogistica &&
            freteCalculado
            " class="btn btn_color_system py-2 px-5 mt-4" @click="continuar()">
            CONTINUAR
          </button>
          <button v-else :disabled="objPedido.pedidoDTO != null &&
            objPedido.pedidoDTO.removerItensSemLogistica &&
            freteCalculado
            " class="btn btn_color_system py-2 px-5 mt-4" @click="continuarPagamento()">
            CONTINUAR
          </button>
          <router-link :to="`${MODULOS.LANDING ? '/loja' : '/'}`" tag="a" class="btn btn-secondary px-5 mt-4 py-2">
            VOLTAR
          </router-link>
        </div>
      </div>


    </article>
  </main>
</template>

<script>
import { APIService } from '../../APIService'
const apiService = new APIService()

export default {
  name: 'StepConfirmarPedido',
  components: {},
  props: ['objPedido'],
  data() {
    return {
      MODULOS: window.MODULOS,
      freteError: '',
      cupomError: '',
      freteCalculado: false,
      cep: '',
      loading: false,
      quantidadeParcelas: 1,
      quantidadeMaximaParcelasConfig: null,
      loadingCalcularFrete: false,
      loadingAplicarCupom: false,
      listItens: [],
      cupomDesconto: '',
      cupom: null,
    }
  },
  mounted() {
    this.initCalcularFrete()
  },
  created() {},
  computed: {},
  methods: {
    initCalcularFrete() {
      if (
        this.objPedido != null &&
        this.objPedido.pedidoDTO != null &&
        this.objPedido.pedidoDTO.enderecoEntrega != null
      ) {
        this.calcularFrete()
      } else {
        this.objPedido.pedidoDTO.enderecoEntrega = { cep: null }
        setTimeout(() => this.initCalcularFrete(), 300)
      }
    },
    alterarOpcaoFrete(itemId, freteId) {
      this.loadingCalcularFrete = true
      this.freteCalculado = false
      this.freteError = ''

      apiService
        .alterarOpcaoFrete(itemId, freteId, this.objPedido.pedidoDTO)
        .then((response) => {
          this.objPedido.pedidoDTO = response
          this.freteCalculado = true
          if (response) {
            this.setPedidoToLocalStorage(response);
          }
        })
        .catch((error) => {
          this.freteError = error.response.data.title
        })
        .finally(() => {
          this.loadingCalcularFrete = false
        })
    },
    continuar() {
      if (!this.objPedido.pedidoDTO.enderecoEntrega || this.objPedido.pedidoDTO.enderecoEntrega.cep == "") {
        this.freteError = 'Preencha o CEP de Entrega'
      } else {
        this.$emit(
          'goToStep',
          'endereco',
          this.objPedido.pedidoDTO.enderecoEntrega,
        )
      }

    },
    continuarPagamento() {
      this.$emit(
        "goToStep",
        "pagamento",
        this.objPedido.pedidoDTO.enderecoEntrega);
    },
    imagemPrincipal(list) {
      const item = list.find((o) => o.imagemPrincipal)

      return item && list && list.length
        ? item.urlImagem || list[0].urlImagem
        : 'https://pagglo-cdn.s3.amazonaws.com/app/assets/sem_foto.png'
    },
    excluirItem(itemId, quantidade) {
      this.loading = true
      this.loadingCalcularFrete = true
      this.freteError = ''

      apiService
        .excluirItemPedido(itemId, quantidade, this.objPedido.pedidoDTO)
        .then((response) => {
          this.objPedido.pedidoDTO = response
          if (response.removerItensSemLogistica) {
            this.freteError =
              'Alguns itens do seu carrinho não tem empresa de logística disponível para realizar entrega no CEP informado, remova os itens para continuar a compra.'
          }

          if (response) {
            this.setPedidoToLocalStorage(response)
          }

          if (response.status == 'CANCELADO') {
            localStorage.removeItem('codigoLoja')
            localStorage.removeItem('carrinho')
            localStorage.removeItem('idCarrinho')
            this.$store.dispatch('limparPedido')
            this.$router.push('/')
          }
          this.loading = false
        })
        .catch((error) => {
          this.freteError = error.response.data.title
        })
        .finally(() => {
          this.loadingCalcularFrete = false
          this.loading = false
        })
    },
    cancelPayment() {
      this.$swal({
        title: "Tem certeza que deseja limpar o carrinho? Todos os produtos serão removidos!",
        confirmButtonText: "Ok",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        preConfirm: () => {
          this.loading = true;
          apiService.cancelPayment(this.objPedido.pedidoDTO.id).then(() => {
            localStorage.removeItem("codigoLoja");
            localStorage.removeItem("idCarrinho");
            this.$store.dispatch("limparPedido");
            this.$router.push(`/`);
          });
        },
      });
    },
    calcularFrete() {
      this.loadingCalcularFrete = true
      //this.loading = true;
      this.freteCalculado = false
      if (this.objPedido.pedidoDTO.enderecoEntrega.cep) {
        const cep = this.objPedido.pedidoDTO.enderecoEntrega.cep.replace(
          '-',
          '',
        )
        this.freteError = ''
        apiService
          .obterFrete(cep, this.objPedido.pedidoDTO)
          .then((response) => {
            this.$emit('obterCep', cep)
            this.objPedido.pedidoDTO = response
            this.freteCalculado = true

            if (response) {
              this.setPedidoToLocalStorage(response)
            }

            if (response.removerItensSemLogistica) {
              this.freteError =
                'Alguns itens do seu carrinho não tem empresa de logística disponível para realizar entrega no CEP informado, remova os itens para continuar a compra.'
            }
          })
          .catch((error) => {
            this.freteError = error.response.data.title
          })
          .finally(() => {
            this.loadingCalcularFrete = false
            this.loading = false;
          })
      } else {
        this.loadingCalcularFrete = false;
        if (this.objPedido.pedidoDTO.possuiProdutoFisico == true) {
          this.freteError = "CEP não encontrado";
        }
        //this.freteError = error.response.data.title;
      }
    },
    calcAdicional(produto) {
      let valorAdicional = 0
      produto.categoriaModificadorList.forEach((el) => {
        el.produtoModificadorList.forEach((pr) => {
          valorAdicional += pr.valorUnitario + pr.valorFreteAdicional
        })
      })
      return valorAdicional
    },
    categoriasFiltrada(modificador) {
      let produtoCategoria = []
      modificador.forEach((element) => {
        let dados = element.produtoModificadorList.filter(
          (o) => o.valorUnitario > 0,
        )
        if (dados.length > 0) {
          dados.forEach((o) => {
            produtoCategoria.push(o)
          })
        }
      })
      return produtoCategoria
    },
    adicionar(add, item) {
      this.loading = true
      const action = add ? 'pedidoAdicionarProduto' : 'pedidoRemoverProduto'
      const tempItem = {
        produto: item.produto,
        quantidade: 1,
      }
      this.$store.dispatch(action, tempItem)

      let token = localStorage.getItem('accessToken')

      if (!this.$store.state.user && token) {
        this.loading = false
        return
      }

      setTimeout(() => {
        this.atualizarItensCarrinho(this.$store.state.pedido)
      }, 1000)
    },
    atualizarItensCarrinho(pedido) {
      apiService.atualizarItensCarrinho(pedido).then(() => {
        apiService
          .getPedidoPendente()
          .then((response) => {
            this.objPedido.pedidoDTO.itens = response.itens
            localStorage.setItem('carrinho', JSON.stringify(response))
          })
          .finally(() => (this.loading = false))
      })
    },
    setPedidoToLocalStorage(pedido) {
      this.$store.state.pedido.itens = []
      this.$store.state.pedido.valorTotal = 0
      this.$store.state.pedido.valorFrete = 0
      this.$store.state.pedido.valorCompra = 0
      this.$store.state.pedido.valorDesconto = 0
      this.$store.state.pedido.id = null

      if (pedido.status === 'AGUARDANDO_CHECKOUT') {
        this.$store.state.pedido.itens = pedido.itens
        this.$store.state.pedido.valorTotal = pedido.valorTotal
        this.$store.state.pedido.valorFrete = pedido.valorFrete
        this.$store.state.pedido.valorCompra = pedido.valorCompra
        this.$store.state.pedido.valorDesconto = pedido.valorDesconto
        this.$store.state.pedido.id = pedido.id
      }

      setTimeout(() => {
        localStorage.setItem(
          'carrinho',
          JSON.stringify(this.$store.state.pedido),
        )
      }, 500)
    },
    aplicarCupom() {
      this.cupomError = ''

      if (!this.cupomDesconto) {
        this.cupomError = 'Preencha o cupom para utilizá-lo'
        return
      }

      this.loading = true
      this.loadingAplicarCupom = true

      apiService
        .aplicarCupomDesconto(this.objPedido.pedidoDTO.id, this.cupomDesconto)
        .then((response) => {
          if (!response.enderecoEntrega) {
            response.enderecoEntrega = this.enderecoVazio();
          }

          this.objPedido.pedidoDTO = response;

          if (response) {
            this.setPedidoToLocalStorage(response)
            this.calcularFrete();
           }
          this.cupomError = ''
        })
        .catch((error) => {
          this.cupomError = error.response.data.title
          this.loading = false
        })
        .finally(() => {
          this.loadingAplicarCupom = false
        })
    },
    removerCupom() {
      this.loading = true
      this.loadingAplicarCupom = true
      apiService
      .removerCupomDesconto(
        this.objPedido.pedidoDTO.id,
        this.objPedido.pedidoDTO.cupom.id,
        )
        .then((response) => {
          if (!response.enderecoEntrega) {
            response.enderecoEntrega = this.enderecoVazio();
          }
          
          this.objPedido.pedidoDTO = response;
          
          if (response) {

            this.setPedidoToLocalStorage(response)
            this.calcularFrete();
          }
          this.cupomError = ''
        })
        .catch((error) => {
          this.cupomError = error.response.data.title
          this.loading = false
        })
        .finally(() => {
          this.loadingAplicarCupom = false
        })
    },
    enderecoVazio() {
      return {
        cep: "",
        endereco: "",
        complemento: "",
        numero: "",
        bairro: "",
        cidade: "",
        estado: "",
        pais: "",
      };
    },
  },
}
</script>
<style scoped lang="scss">
.loading {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  left: 0;
  top: 0;
}

.custom-input-number button {
  width: 35px;
  height: 35px;
  background-color: #fff;
  color: #757575;
  border: 1px solid #757575;
  border-radius: 50px;
  font-size: 1.2em;
  font-weight: 800;

  &:disabled {
    color: #ccc;
    border-color: #ccc;
  }
}
</style>
